import { Link, TrackingData } from '@ecm/router';

import { TypeEnum } from '../../api/dashboardV7/push/typeEnum';

export class RelationalV7ViewModel {
    public type: TypeEnum;
    public cid?: string;
    public code?: string;
    public title?: string;
    public label?: string;
    public content?: Array<string> | string;
    public text?: string;
    public alt?: string;
    public advTracker?: string;
    public imageUrl?: string;
    public link?: Link;
    public urlLabel?: any;
    public secondaryCode?: any;
    public trackingData: TrackingData;
}
